// 占位符
export const PLACEHOLDER = '请选择内容'
// 资源归属库
export const OPTIONS = [
  {
    value: 'PLATFORM_LIB',
    label: '平台库',
  },
  {
    value: 'INSTITUTION_LIB',
    label: '校本库',
  },
]
// 资源分类
export const TYPE_OPTIONS = [
  {
    value: 'NATION',
    label: '国家课程',
  },
  {
    value: 'SPECIALTY',
    label: '特色课程',
  },
]

// 课程目录
export const CATALOGUEINIT = {
  category: 'NATION',
  open: true, //默认展开目录
  periodDictItemCode: '', //学段
  subjectDictItemCode: '', //学科
  tutorialVersionDictItemCode: null, //版本
  tutorialId: null, // 教材册次id
  firstTutorialDirId: '', //第一级教材目录ID
  secondTutorialDirId: '', //第二级教材目录ID
  threeTutorialDirId: '', //第三级教材目录ID
  fourTutorialDirId: '', //第四级教材目录ID
}

// 特色课程目录
export const SPECIALTY_CATALOGUEINIT = {
  category: 'SPECIALTY',
  open: true, //默认展开目录
  firstDirDictItemCode: '', // 特色课程一类
  firstDirDictItemName: '', // 特色课程一类名称
  secondDirDictItemCode: '', // 特色课程二类
  secondDirDictItemName: '', // 特色课程二类名称
}

//知识点
export const KNOWLEDGEINIT = {
  knowledge: '',
  target: '', //认知目标
  literacy: '', //学科素养
}

//题型
export const EXCERSISE_TYPE = [
  { name: '单选题', value: 'SINGLE_CHOICE' },
  { name: '多选题', value: 'MULTIPLE_CHOICE' },
  { name: '判断题', value: 'JUDGE' },
  { name: '填空题', value: 'COMPLETION' },
  { name: '简答题', value: 'ANSWER_QUESTIONS' },
  { name: '综合题', value: 'COMPREHENSIVE' },
]

// const

// 题目类型键值对
export const EXERCISE_CODE_OBJ = {
  SINGLE_CHOICE: '单选题',
  MULTIPLE_CHOICE: '多选题',
  JUDGE: '判断题',
  COMPLETION: '填空题',
  ANSWER_QUESTIONS: '简答题',
  COMPREHENSIVE: '综合题',
  UNDEFINED: '未定义',
}
// AI助手id
export const ASSISTANT_ID_OBJ = {
  SINGLE_CHOICE: 'bot-20240912105426-rc9l8',
  MULTIPLE_CHOICE: 'bot-20240912110406-jfr6x',
  JUDGE: 'bot-20240912110950-lfvs9',
  COMPLETION: 'bot-20240912111851-cb7kn',
  ANSWER_QUESTIONS: 'bot-20240912112340-nb56t',
  COMPREHENSIVE: 'bot-20240912112730-qtjx2',
}

// 习题类型枚举
export const EXERCISE_TYPE_ENUM = {
  SINGLE_CHOICE: 1,
  MULTIPLE_CHOICE: 2,
  COMPLETION: 3,
  JUDGE: 4,
  ANSWER_QUESTIONS: 5,
  COMPREHENSIVE: 6,
}
